let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6Ue6S")).then(() => parcelRequire('A6kZA'));